import { withInstall } from '@pc-fx-framework/utils/with-install'
import VModal from './src/index.vue'

export const FxVModal = withInstall(VModal)
export default FxVModal
